/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.lhr-viewer-button {
  background: var(--highlighted-background-color);
  border-radius: 3px;
  padding: calc(var(--base-spacing) / 2);
  margin-right: var(--base-spacing);

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  color: var(--base-text-color);
  font-weight: var(--medium-font-weight);
  overflow: hidden;
  white-space: nowrap;
}

.lhr-viewer-button img {
  height: var(--lhr-viewer-button-size);
  width: var(--lhr-viewer-button-size);
}

.lhr-viewer-button span {
  margin-left: calc(var(--base-spacing) / 2);
  padding-right: calc(var(--base-spacing) / 2);
}

@media (max-width: 1000px) {
  .lhr-viewer-button {
    border-radius: 100%;
  }
  .lhr-viewer-button span {
    display: none;
  }
}
